module.exports = __webpack_public_path__ + "img/white.1ed82fa0.png";